/* src/app/components/participant-leads-list/participant-leads-list.component.css */
.ref-head-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.create-button {
  padding: 4px 5px;
}
.button-sec {
  margin-bottom: 8px;
}
.main {
  width: 96%;
  margin: auto;
}
h2 {
  font-size: 1.286rem;
}
.action {
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  font-style: italic;
  font-weight: 700;
  color: darkslategrey;
}
.table-style {
  width: 100%;
}

/* src/app/components/payroll/invoices/invoice-payroll-processing/invoice-payroll-processing.component.css */
.grid-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.submit-processing-form {
  padding: 8px 4px;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
/*# sourceMappingURL=invoice-payroll-processing.component-KDRUOG47.css.map */
